// @flow
import invariant from 'invariant';
import * as React from 'react';
import type { PageType } from 'api/cms';
import MultiBlock from 'components/MultiBlock';
import Field from './Field';

const MultiBlockField = ({
  name,
  label,
  description,
  placeholder,
  minInputs = 1,
  maxInputs,
  disabled,
  forScheduledContent,
  forSidebars,
  errorsByBlock,
  subsiteId,
  locale,
  pageType,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  placeholder?: string,
  minInputs?: number,
  maxInputs?: number,
  disabled?: boolean,
  forScheduledContent?: boolean,
  forSidebars?: boolean,
  errorsByBlock?: Array<boolean>,
  subsiteId?: string,
  locale: string,
  pageType?: PageType
}) => (
  <Field
    name={name}
    label={label}
    description={description}
    inputProps={props}
    renderInput={({ value, id, qaId, updateValueWith, errors }) => {
      invariant(Array.isArray(value), 'Invalid value for MultiBlockField');
      return (
        <MultiBlock
          id={id}
          name={name}
          values={value}
          errors={errors}
          minInputs={minInputs}
          maxInputs={maxInputs}
          data-qa-id={qaId}
          placeholder={placeholder}
          disabled={disabled}
          forScheduledContent={forScheduledContent || false}
          forSidebars={forSidebars || false}
          errorsByBlock={errorsByBlock}
          subsiteId={subsiteId || ''}
          locale={locale}
          pageType={pageType}
          updateValueWith={updateValueWith}
          {...props}
        />
      );
    }}
  />
);

export default MultiBlockField;
